import React, { Component, useState } from 'react';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
export const PersonalCategorysection = props => {
    const { subcategoryId, subcategoryIdError, CategoryId, CategoryIdError, toggle3, CategoryList, subcetgoryList, onChangeCategory, onChangeSubCategory, Static, Dynamic, onchangeStaticCheckbox, onchangeDynamicCheckbox, isStaticfixed } = props;

    return (
        <Panel className="bg-grey  mb-0">
            <PanelHeader>
                <h4 className='mb-0 text-white'>
                    Category
                </h4>
            </PanelHeader>
            <PanelBody>
                <div className="form-group">
                    <label htmlFor="exampleInputPassword1">Select Main category</label>
                    <div className="d-flex">
                        <select class="default-select2  form-control input-width" value={CategoryId} onChange={onChangeCategory}>
                            <option value="" selected>Select Category</option>
                            {CategoryList.map((item, i) => (
                                <option key={i} value={item._id}>{item.name}</option>
                            ))}
                        </select>
                        <div>
                            <button type="submit" onClick={toggle3} className="btn btn-purple m-l-15 shadow-add"> <i class='fas fa-lg fa-fw fa-plus-square icon'></i></button>
                        </div>

                    </div>
                    {CategoryIdError.length > 0 &&
                        <span style={{ color: 'red', marginLeft: 6 }}>{CategoryIdError}</span>}
                </div>

                <div className="form-group">
                    <label htmlFor="exampleInputPassword1">Select Sub category</label>
                    <div className="">
                        <select class="default-select2  form-control input-width" value={subcategoryId} onChange={onChangeSubCategory}>
                            <option value="" selected>Select Subcategory</option>
                            {subcetgoryList.map((item, i) => (
                                <option key={i} value={item._id}>{item.name}</option>
                            ))}

                        </select>
                        {subcategoryIdError.length > 0 &&
                            <span style={{ color: 'red', marginLeft: 6 }}>{subcategoryIdError}</span>}
                    </div>

                </div>
                {
                    isStaticfixed !== true ?
                        <div className='row m-b-15'>
                            <div className='col-md-12'>
                                <div className="checkbox checkbox-css checkbox-inline">
                                    <input type="checkbox" checked={Dynamic} value="" id="DynamicCheckbox" onChange={(e) => { onchangeDynamicCheckbox(e) }} />
                                    <label htmlFor="DynamicCheckbox">{"Dynamic"}</label>
                                </div>
                            </div>
                        </div>
                        : <></>
                }


                <div className='row m-b-15 m-t-15'>
                    <div className='col-md-12'>
                        <div className="checkbox checkbox-css checkbox-inline">
                            <input type="checkbox" checked={Static} id="StaticCheckbox" onChange={(e) => { onchangeStaticCheckbox(e) }} />
                            <label htmlFor="StaticCheckbox">{"Static"} </label>
                        </div>
                    </div>

                </div>

            </PanelBody>

        </Panel>
    )
}